module.exports = __webpack_public_path__ + "static/media/wanglongli.eef3d873.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/wanglongli.webp
// module id = 225
// module chunks = 0